export default "__VITE_PUBLIC_ASSET__c593c81b__"